import React, { Component } from 'react';
import { DoctorList }       from './DoctorList';
import AuthService          from 'services/auth.service';
import AssistantService     from 'services/assistant.service';
import queryString          from 'query-string';
import PreviousBtn          from 'assets/icons/Previous.svg';
import NextBtn              from 'assets/icons/Next.svg';
import Search               from 'assets/icons/Search.svg';

const currentAssistant  = AuthService.getCurrentAssistant();

class AssistantDashboard extends Component {
  constructor(props) {
    super(props);

    this.state = {
      page: 1,
      total_pages: 1,
      name: '',
      doctors: []

    };
  }

  listDoctors() {
    const parameters = queryString.stringify({
      page: this.state.page,
      name: this.state.name
    });

    AssistantService.list_doctors(parameters).then(
      (data) => {
        this.setState({
          doctors: data.doctors,
          page: data.metadata.current_page,
          total_pages: data.metadata.total_pages
        });
      },
      (error) => {
        console.log(error.response);

        if (error.response.status === 401) {
          AuthService.logout();
          window.location.replace('/eb/login');
        }
      }
    );
  };

  componentDidMount() {
    const currentPage = queryString.parse(this.props.search);
    const name        = currentPage.name || '';

    this.setState({
      name: name
    }, this.listDoctors);
  }

  handlePage(previous) {
    var pageNumber    = this.state.page;
    const totalPages  = this.state.total_pages;

    if (previous) {
      pageNumber = pageNumber === 1 ? 1 : pageNumber - 1;
    } else {
      pageNumber = pageNumber === totalPages ? totalPages : pageNumber + 1;
    }

    this.setState({ page: pageNumber }, this.listDoctors);
  }

  handleEnterKey(e) {
    if (e.key === 'Enter') {
      this.setState({
        page: 1
      }, this.listDoctors);
    }
  }

  render() {
    return (
      <div id="main-content-target">
        <div className="d-sm-flex justify-content-between align-items-end">
          <h1 className="text-danger mb-4">Doctors at { currentAssistant?.clinic_name }</h1>
        </div>

        <div className="d-sm-flex align-items-end">
          <span className="search-box d-block d-sm-inline-block" style={{ width: '30em' }}>
            <img src={ Search } alt="search-icon" id="search-icon" />

            <input
              type="text"
              placeholder="Search for doctor/facility"
              className="form-control rounded-pill"
              value={ this.state.name }
              onChange={(e) => this.setState({ name: e.target.value }) }
              onKeyDown={(e) => this.handleEnterKey(e) }
            />
          </span>

          <div className="d-none d-sm-block flex-grow-1"></div>

          <div className="ml-sm-4 my-2 my-sm-0 mb-0">
            <button onClick={() => this.handlePage(true) } style={{ border: "none", backgroundColor: "#F2F2F2" }}>
              <img src={ PreviousBtn } alt="previous" className="page-prev-btn" />
            </button>

            <b className="font-size-6 px-2">{ this.state.page } of { this.state.total_pages }</b>

            <button onClick={() => this.handlePage(false) } style={{ border: "none", backgroundColor: "#F2F2F2" }}>
              <img src={ NextBtn } alt="next" className="page-next-btn" />
            </button>
          </div>
        </div>

        <DoctorList items={ this.state.doctors } />
      </div>
    )
  }
}

export default AssistantDashboard;